<script setup lang="ts">
import { type AanvragenDomainEntitiesOntvangerDirectePost as OntvangerDirectePost } from '@services/polis-public/orval-api/model/aanvragenDomainEntitiesOntvangerDirectePost';
import VModal from '@shared/component/VModal/VModal.vue';
import { computed, ref } from 'vue';

import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import VRadioField from '@shared/form/VRadioField/VRadioField.vue';
import FieldRowGroup from '@shared/form/FieldRowV2/FieldRowGroup.vue';
import { usePakketpolisStore } from '../pakketpolisStore';

export type StartMutatie = {
  ontvangerDirectePost: OntvangerDirectePost;
};

const props = defineProps<{
  pakketpolisnummer: string;
}>();

const emit = defineEmits<{
  startMutatie: [StartMutatie];
}>();

const store = usePakketpolisStore();
const pakketpolis = computed(() => store.getPakketpolis(props.pakketpolisnummer));
const ontvangerRoyementsbevestiging = ref<OntvangerDirectePost>(
  pakketpolis.value?.originelePakketpolis.ontvangerDirectePost ?? 'Adviseur',
);
const isPakketpolisRoyement = computed(() => store.getPakketGeroyeerd(props.pakketpolisnummer));
const confirmButtonText = computed(() =>
  isPakketpolisRoyement.value ? 'Bevestigen' : 'Start mutatie',
);
const isOpen = defineModel<boolean>('isOpen');

function start() {
  emit('startMutatie', {
    ontvangerDirectePost: ontvangerRoyementsbevestiging.value,
  });
  isOpen.value = false;
}
</script>

<template>
  <VModal
    overflow
    :confirm-button-text="confirmButtonText"
    @close-modal="isOpen = false"
    @confirm-action="start"
    invert-header
    title="Royement bevestiging"
    :is-active="isOpen"
    data-testid="royementsbevestiging-modal"
  >
    <FieldRowGroup :gap="2">
      <FieldRowV2
        label-on-own-row
        label="Royementsbevestiging mailen naar"
        tooltip="Op basis van de geselecteerde optie wordt de royementsbevestiging rechtstreeks naar de relatie, adviseur of beiden verstuurd."
      >
        <VRadioField
          v-model:value="ontvangerRoyementsbevestiging"
          name="ontvangerRoyementsbevestiging"
          :options="[
            { label: 'Relatie', value: 'Relatie' },
            { label: 'Adviseur', value: 'Adviseur' },
            { label: 'Beide', value: 'Beide' },
          ]"
        />
      </FieldRowV2>
      <FieldRowV2 v-if="isPakketpolisRoyement" label-on-own-row label="Bevestiging royement">
        Weet je zeker dat je het royement definitief wilt maken en de gegevens correct zijn
        ingevoerd?
      </FieldRowV2>
    </FieldRowGroup>
  </VModal>
</template>
